export default {"src":"/uk/_next/static/media/beeIcon.c841d732.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};